module.exports = __webpack_public_path__ + "img/Modern.2c449fda.svg";